module.exports = {
      id: "e4147cb32f2fbe07bd5af6114c889a45electricity-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#e4147cb32f2fbe07bd5af6114c889a45electricity-none.svg",
      toString: function () {
        return this.url;
      }
    }